// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5i-1";
export var standaloneTable = "_5i-0";